<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [removable]="true" [entityPath]="fieldName" [title]="'wbo.report.employee-selection.title'">
    <wbo-text-column field="firstName" [title]="'wbo.report.employee-selection.column.firstName'"></wbo-text-column>
    <wbo-text-column field="lastName" [title]="'wbo.report.employee-selection.column.lastName'"></wbo-text-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromEmployee([$event])">
            <wbo-employee-single-select-edit-control></wbo-employee-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search [searchComponent]="EmployeeSearchPageComponent" (onSelect)="addFromEmployee($event)"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
